import { useCallback, useEffect, useRef } from "react";

const CLICK_COOLDOWN_MS = 500;

const CooldownButton = ({ onClick, children, ...props }) => {
  const ref = useRef(null);
  const timeoutRef = useRef(null);

  const handleClick = useCallback(
    e => {
      if (ref.current) {
        ref.current.style.pointerEvents = "none";
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          if (ref.current) ref.current.style.pointerEvents = "";
        }, CLICK_COOLDOWN_MS);
      }
      onClick?.(e);
    },
    [onClick],
  );

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return (
    <button ref={ref} onClick={handleClick} {...props}>
      {children}
    </button>
  );
};

export default CooldownButton;
